import type { Question, QuestionOption } from "../types/onboarding";

/**
 * Get translated text for profile selection options
 */
export function getProfileOptionText(
	option: QuestionOption,
	t: (key: string) => string,
): string {
	switch (option.value) {
		case "b2c":
			return t("questions.profileSelect.options.intendedParent");
		case "partner":
			return t("questions.profileSelect.options.supportingDescription");
		default:
			return option.description || "";
	}
}

/**
 * Get the primary option from profile select question
 */
export function getPrimaryProfileOption(
	question: Question,
): QuestionOption | undefined {
	return question.options?.find((option) => option.value === "b2c");
}

/**
 * Get secondary options from profile select question
 */
export function getSecondaryProfileOptions(
	question: Question,
): QuestionOption[] {
	return question.options?.filter((option) => option.value !== "b2c") || [];
}

/**
 * Get translated question title
 */
export function getTranslatedQuestionTitle(
	question: Question,
	t: (key: string) => string,
): string {
	const titleKeyMap: Record<string, string> = {
		"Choose your profile:": "questions.profileSelect.title",
		"Help us personalize your experience": "questions.personalInfo.title",
		"Which one describes you the best:": "questions.genderRelationship.title",
		"Which parts of the journey apply to you?": "questions.fertilityPath.title",
		"What would you like to do with Era?": "questions.interests.title",
		"Do you already have a fertility clinic or provider?":
			"questions.clinicProvider.title",
	};

	const translationKey = titleKeyMap[question.title];
	return translationKey ? t(translationKey) : question.title;
}
